import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  AiStarFilled,
  Edit,
  StatusChange,
  TrashCan,
  UsersAccess,
} from '@mint-lib/icons';
import { Divider } from '@mint-lib/tw-components';

import { ActionMenu, ActionMenuItem } from '../../ActionMenu.jsx';

type Props = {
  canManage: boolean;
  onRename: () => void;
  onDelete?: () => void;
  onMove?: () => void;
  onShare?: () => void;
  className?: string;
};

const FolderActionsCell = ({
  canManage,
  onRename,
  onDelete,
  className,
  onMove,
  onShare,
}: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');
  const [open, setOpen] = useState(false);

  if (!canManage) return;

  const handleRename = () => {
    onRename();
    setOpen(false);
  };

  const handleShare = () => {
    setOpen(false);
    onShare?.();
  };

  const handleDelete = () => {
    onDelete?.();
    setOpen(false);
  };

  return (
    <ActionMenu
      open={open}
      onOpenChange={setOpen}
      aria-label="folder-actions-button"
      data-dd-action-name="Knowledge base: open folder actions"
      className={className}
    >
      {onShare && (
        <ActionMenuItem
          aria-label="share-folder"
          data-dd-action-name="Knowledge base: share folder"
          onClick={handleShare}
          startIcon={<UsersAccess className="fill-text-primary" />}
          label={t('Share')}
        />
      )}
      <ActionMenuItem
        //onClick={() => {}}
        aria-label="ask-mintiq-folder"
        startIcon={<AiStarFilled className="text-text-primary" />}
        label={t('Ask MintIQ')}
      />
      <ActionMenuItem
        aria-label="rename-folder"
        data-dd-action-name="Knowledge base: rename folder"
        onClick={handleRename}
        startIcon={<Edit className="fill-text-primary" />}
        label={t('Rename')}
      />
      {onMove && (
        <ActionMenuItem
          onClick={onMove}
          aria-label="move-folder"
          startIcon={<StatusChange className="fill-text-primary" />}
          label={t('Move to')}
        />
      )}
      {onDelete && (
        <>
          <Divider />
          <ActionMenuItem
            aria-label="delete-folder"
            data-dd-action-name="Knowledge base: delete folder"
            onClick={handleDelete}
            startIcon={<TrashCan className="fill-error-dark" />}
            label={t('Delete')}
            tone="danger"
          />
        </>
      )}
    </ActionMenu>
  );
};

export { FolderActionsCell };
